import { Component, Inject, Input, OnInit } from '@angular/core';
import {
  MasterPayrollObject,
  PayDateInfoEx,
  PayrollStartConfig,
  PayrollStartData,
  PayTypes
} from '../../../../models/payroll';
import { Router } from '@angular/router';
import { PayrollService } from '../../../../services/payroll.service';
import { InstanceTypes } from '../../../../models/instance-types';
import { IsPayDateInvalid } from '../PaydateValidationFunction';
import { PayrollManagement } from '../../../../tools/payroll-management';
import { ClientSetup } from '../../../../models/client';
import { BaseClientComponent } from '../../../../components/base/base-client.component';
import { ModalService } from '../../../../services/modal.service';
import { ModalStates } from '../../../../models/modal';

@Component({
  selector: 'run-payroll-tile',
  templateUrl: './run-payroll-tile.component.html',
  styleUrls: ['./run-payroll-tile.component.css'],
  standalone: false
})
export class RunPayrollTileComponent extends BaseClientComponent implements OnInit {
  @Input() activeAutoPayGrid: MasterPayrollObject;
  @Input() clientCode: string;
  @Input() clientSetup: ClientSetup;
  @Input() payrollStartData: PayrollStartData;
  @Input() prefundWarnings: string[];

  public dateUntilNextPayrollSubmission: string;
  public daysUntilNextPayrollSubmission: number;
  public payrollStartConfig: PayrollStartConfig;

  get isPayDateInvalid() {
    return (
      this.payrollStartData?.ActivePayroll?.PayType == PayTypes.Regular &&
      IsPayDateInvalid(this.payrollStartData?.ActivePayroll)
    );
  }

  get isClientPortal() {
    return this.env.instanceType == InstanceTypes.ClientPortal;
  }

  get isPrefundLocked() {
    return this.isClientPortal && this.prefundWarnings?.length;
  }

  get isSubmitDisabled() {
    return this.payrollStartConfig.IsLocked;
  }

  get payTypes() {
    return PayTypes;
  }

  constructor(
    private router: Router,
    private payrollService: PayrollService,
    private payrollMgmt: PayrollManagement,
    private modalService: ModalService,
    @Inject('env') private env: any
  ) {
    super();
  }

  ngOnInit(): void {
    this._setDateInfoLeftForPayroll();
    this.payrollStartConfig = this.payrollMgmt.buildPayrollConfig(
      this.clientSetup,
      this.payrollStartData?.ActivePayroll,
      null,
      PayTypes.Regular,
      this.payrollStartData
    );
  }

  //#region Public Methods

  public navigatePayroll() {
    if (this.payrollStartData.ActivePayroll) {
      // the payroll has been started. take user to payroll start/home screen
      this.router.navigate([`/client/${this.clientCode}/payroll/`]);
    } else {
      // no active payroll, direct user to the manual-checks page
      this.router.navigate([`/client/${this.clientCode}/manual-checks`]);
    }
  }

  cancelPayroll() {
    if (
      this.payrollStartData.ActivePayroll != null &&
      this.payrollStartData.ActivePayroll.PayType == PayTypes.Regular
    ) {
      this.payrollMgmt
        .cancelPayroll(
          this.payrollStartData.ActivePayroll.ClientCode,
          this.payrollStartData.ActivePayroll.Year,
          this.payrollStartData.ActivePayroll.SequenceNumber,
          this.payrollStartData.ActivePayroll,
          true
        )
        .subscribe(
          () => {
            window.location.reload();
          },
          err => {
            if (err.status !== 404) {
              this.modalService.showAlertModal(
                `Error Code: ${err.status}\nMessage: An Error has Occurred`,
                ModalStates.Error
              );
            }
            window.location.reload();
          }
        );
    }
  }

  //#endregion

  //#region Private Methods

  private _setDateInfoLeftForPayroll(): void {
    // FIXME: will need addressed when multiple locations are enabled
    let earliestPayDate: PayDateInfoEx;

    if (this.payrollStartData?.ActivePayroll) {
      var location = this.payrollStartData.Locations.find(
        x => x.Id == this.payrollStartData.ActivePayroll.LocationId
      );

      earliestPayDate = location.NextPayDates.find(
        x => x.CalendarId == location.Calendars[0].CalendarId
      );
    } else {
      earliestPayDate = this.payrollStartData.Locations[0].NextPayDates?.reduce((a, b) => {
        return new Date(a.ProcessDueDate) < new Date(b.ProcessDueDate) ? a : b;
      });
    }

    // get days left
    const difference = +new Date(earliestPayDate.ProcessDueDate) - +new Date();

    // if the due date is today or passed, then display 0
    this.daysUntilNextPayrollSubmission =
      difference >= 0 ? Math.floor(difference / (1000 * 3600 * 24)) : 0;
    this.dateUntilNextPayrollSubmission = new Date(
      earliestPayDate.ProcessDueDate
    ).toLocaleDateString('en-us', { day: 'numeric', month: 'long' });
  }

  //#endregion
}
